<template>
  <v-card
    class="a-widget-base"
    :loading="loading"
    elevation="3"
    :height="height"
  >
    <v-card-title class="pb-0 pt-2 flex-gap-2 text-subtitle-1 font-weight-bold">
      <slot name="title"></slot>

      <v-spacer></v-spacer>

      <TableBtn v-if="!hideTableBtn" @click="$emit('click:table')"></TableBtn>

      <RefreshBtn
        :time="lastUpdate"
        @click="$emit('click:refresh')"
      ></RefreshBtn>
    </v-card-title>

    <template v-if="error">
      <div class="d-flex flex-column justify-center align-center pa-4">
        <v-icon color="red" size="64">mdi-alert</v-icon>
        {{ $t("widgets.common.error") }}
        <v-btn class="mt-4" @click="$emit('click:refresh')" text>
          <v-icon left>mdi-refresh</v-icon> {{ $t("_.refresh") }}
        </v-btn>
      </div>
    </template>

    <template v-else>
      <slot name="content"></slot>
    </template>
  </v-card>
</template>
<script>
import RefreshBtn from "./WidgetCard/RefreshBtn.vue";
import TableBtn from "./WidgetCard/TableBtn.vue";

export default {
  components: { RefreshBtn, TableBtn },

  props: {
    error: {
      type: Boolean,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    hideTableBtn: {
      type: Boolean,
      default: false
    },
    lastUpdate: {
      type: Date,
      default: null
    },
    height: {
      type: [Number, String],
      default: 260
    }
  },

  setup() {}
};
</script>

<style lang="scss">
.a-widget-base.v-card {
  display: flex;
  flex-direction: column;
}
</style>
